import { KeyboardEvent as ReactKeyboardEvent } from "react";
import { MentionsInput, Mention } from "react-mentions";
import { StyleMentionInput } from ".";
import { User } from "../../../user/types";

interface Props {
  value: string;
  setValue: (v: string) => void;
  users: User[];
  placeholder?: string;
  onEnterKeypress?: () => void;
}

const MentionsInputComponent = ({
  value,
  setValue,
  users: propsUsers,
  placeholder = "Type your reply here...",
  onEnterKeypress,
}: Props) => {
  const users = propsUsers.map(user => ({
    ...user,
    display: user.display_name,
  }));
  const onKeyDown = (
    e: ReactKeyboardEvent<HTMLInputElement> | ReactKeyboardEvent<HTMLTextAreaElement>
  ) => {
    // dbt docs has shortcut `T` to open search. when typing in this textbox, search is opened whenever t key is pressed
    e.stopPropagation();
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onEnterKeypress?.();
    }
  };

  const onAdd = (id: string | number, display: string) => {
    console.info(`[MentionsInputComponent] on mention select`, { id, display });
  };

  const handleChange = (e: { target: { value: string } }) => {
    setValue(e.target.value);
  };

  return (
    <MentionsInput
      autoFocus
      value={value}
      onChange={handleChange}
      style={{
        ...StyleMentionInput,
        minHeight: "40px",
        marginBottom: "10px",
      }}
      placeholder={placeholder}
      className="mentions-input"
      onKeyDown={onKeyDown}
    >
      <Mention
        displayTransform={(_id, display) => `@${display}`}
        trigger="@"
        markup="@[__id__](__display__)"
        data={users}
        appendSpaceOnAdd
        renderSuggestion={(highlightedDisplay, focused) => (
          <div className={`user ${focused ? "focused" : ""}`}>{highlightedDisplay.display}</div>
        )}
        onAdd={onAdd}
      />
    </MentionsInput>
  );
};

export default MentionsInputComponent;
